import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--scrollspy"
export default class extends Controller {
  static targets = ["link", "section"];

  static values = {
    margin: { type: Number, default: 100 },
  };

  connect() {
    // Initialize with the first section active
    if (this.linkTargets.length > 0) {
      this.setActiveLink(0);
    }

    // Add scroll event listener
    this.scrollHandler = this.handleSpyScroller.bind(this);
    window.addEventListener("scroll", this.scrollHandler);

    // Initial check
    this.handleSpyScroller();
  }

  disconnect() {
    // Clean up event listener when controller disconnects
    window.removeEventListener("scroll", this.scrollHandler);
  }

  handleSpyScroller() {
    if (this.sectionTargets.length === 0) return;

    // Find the current section in view
    const currentSection =
      this.sectionTargets.length -
      [...this.sectionTargets]
        .reverse()
        .findIndex(
          (section) => window.scrollY >= section.offsetTop - this.marginValue
        ) -
      1;

    // Update active link if changed
    if (currentSection !== this.currentActiveSection) {
      this.setActiveLink(currentSection);
    }
  }

  setActiveLink(index) {
    // Remove active class from all links
    this.linkTargets.forEach((link) => {
      link.classList.remove("scrollspy-active");
    });

    // Add active class to current link
    if (this.linkTargets[index]) {
      this.linkTargets[index].classList.add("scrollspy-active");
    }

    this.currentActiveSection = index;
  }

  scrollToSection(event) {
    event.preventDefault();
    const section = event.target.getAttribute("data-index");
    const sectionElement = this.sectionTargets[section];

    if (sectionElement) {
      const y = sectionElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: y - 104, behavior: "smooth" });
    }
  }
}
